// Gestion du thème clair / sombre.
//
// Le choix est enregistré dans localStorage (et non sessionStorage) : c'est une
// préférence d'affichage, pas une donnée de connexion — elle doit survivre à la
// fermeture de l'onglet, contrairement à la session.
//
// Si l'utilisateur n'a jamais choisi, on suit le réglage de son système
// d'exploitation (Windows : Paramètres → Personnalisation → Couleurs).

const CLE = 'vigie-theme';

export const THEMES = ['light', 'dark'];

/** Préférence enregistrée, ou null si l'utilisateur n'a jamais choisi. */
export function themeEnregistre() {
  try {
    const valeur = localStorage.getItem(CLE);
    return THEMES.includes(valeur) ? valeur : null;
  } catch (e) {
    // Navigateur en navigation privée ou stockage bloqué : on ignore.
    return null;
  }
}

/** Thème préféré du système d'exploitation. */
export function themeSysteme() {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
}

/** Thème à appliquer : le choix de l'utilisateur, sinon celui du système. */
export function themeActuel() {
  return themeEnregistre() || themeSysteme();
}

/** Pose l'attribut data-theme sur <html> — c'est lui qui déclenche le CSS. */
export function appliquerTheme(theme) {
  const valide = THEMES.includes(theme) ? theme : 'light';
  document.documentElement.setAttribute('data-theme', valide);
  // Indique au navigateur d'assortir les ascenseurs et les champs natifs.
  document.documentElement.style.colorScheme = valide;
  return valide;
}

/** Enregistre puis applique le thème choisi. */
export function definirTheme(theme) {
  try {
    localStorage.setItem(CLE, theme);
  } catch (e) {
    // Sans stockage, le thème reste actif jusqu'au rechargement de la page.
  }
  return appliquerTheme(theme);
}

/**
 * À appeler une seule fois au démarrage, avant le rendu de React, pour éviter
 * que la page n'apparaisse une fraction de seconde en clair avant de basculer.
 */
export function initialiserTheme() {
  return appliquerTheme(themeActuel());
}
